import React from "react";
import CanvasUI from "@/pages/CanvasUI";

const Home: React.FC = () => {
  return <CanvasUI />;
};

export default Home;


